import { array } from 'fp-ts';
import { useCallback } from 'react';
import { NestedCard, Typography, Stack } from '@optimus-web/core';
import { LocalizedText, useAPI } from '@mews/framework';
import { OptimusPlainLink } from '@mews-commander/ui';
import { TextKey } from '@mews-commander/enums';
import { SalesforceArticleInfo } from '@mews-commander/data-access';
import { useCommanderThunkDispatch } from '@mews-commander/utils';
import { navigateToArticle, searchArticles } from '../actions';
import { ARTICLE_SUGGESTION_LIMIT } from '../constants';

interface Props {
    searchToken: string;
}

export const ArticleSuggestion = ({ searchToken }: Props) => {
    const dispatch = useCommanderThunkDispatch();
    const call = useCallback(
        async () => dispatch(searchArticles(searchToken, ARTICLE_SUGGESTION_LIMIT)),
        [dispatch, searchToken]
    );
    const { data } = useAPI(call, { articles: [] });

    if (data.articles === undefined || data.articles === null || data.articles?.length === 0) {
        return null;
    }

    return (
        <NestedCard variant="subtle">
            <Stack spacing="100" vertical>
                <Typography textStyle="bodySmallStrong" as="div">
                    <LocalizedText textKey={TextKey.SuggestedArticlesTitle} />
                </Typography>
                {array.map(({ title, id, url }: SalesforceArticleInfo) => (
                    <OptimusPlainLink
                        key={id}
                        href={url}
                        onClick={() => dispatch(navigateToArticle(url, id, 'SuggestedArticle'))}
                        data-test-suggested-article-id={id}
                    >
                        {title}
                    </OptimusPlainLink>
                ))(data.articles)}
            </Stack>
        </NestedCard>
    );
};
